global.axios = require('axios');
global.$ = global.jQuery = require('jquery');
global.lity = require('lity');

require('./imagesloaded');

require('./scripts');
require('./home');
require('./menu');
require('./form-builder');
require('./image-protection');
require('./jquery.fitvids');
require('./shared');
